import { makeStyles } from '@mui/styles';

const style = makeStyles((theme?: any) => ({
  segment: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  card: {
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  [theme.breakpoints.up('md')]: {
    segment: {
      paddingTop: theme.spacing(12),
      paddingBottom: theme.spacing(12),
    },
  },
}));

export default style;
